<template>
        <div class="warp">
            <!-- 面包屑 -->
            <!-- <breadcrumb :back="false" :crubList="[{name:'担保服务管理'},{name:'经开区中小担申请列表'}]" :title="'经开区中小担申请列表'"/> -->
            <!-- 查询条件 -->
            <div class="retrieve border" ref="condition">
                <div class="left">
                    <div class="child">
                        <span class="name">担保进度</span>
                        <el-select v-model="sendInfoOne.rate" placeholder="请选择" size="small" clearable>
                            <el-option
                            v-for="item in statusList"
                            :key="item.value"
                            :label="item.name"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="child">
                        <span class="name">提交日期</span>
                        <el-date-picker
                            size="small"
                            v-model="dateS"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            type="datetimerange"
                            :default-time="['24:00:00','23:59:59']"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                        </el-date-picker>
                    </div>
                    <div class="child super_select">
                        <span class="name">检索</span>
                        <el-select v-model="getSelect" placeholder="请选择" size="small" clearable>
                            <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                        <el-input v-model="getValue" placeholder="请输入" size="small" clearable></el-input>
                    </div>
                    <el-button type="primary" size="small" @click="getData" class="retrievalBtn">查询</el-button>
                    <el-button  size="small" @click="onReset" class="retrievalBtn">重置</el-button>
                </div>
            </div>
            <!-- 表格 -->
            <el-table
                :data="tableData"
                @sort-change="sortChange"
                ref="table"
                fit
                :height="bHeight"
                :header-cell-style="headerStyle"
                v-loading="loading"
                element-loading-text="请求中......"
                style="width: 100%">
                <el-table-column
                    prop="id"
                    show-overflow-tooltip
                    
                    label="申请ID">
                </el-table-column>
                <el-table-column
                    prop="createUserName"
                    show-overflow-tooltip
                    
                    label="账号">
                </el-table-column>
                <el-table-column
                    prop="createName"
                    show-overflow-tooltip
                    
                    label="姓名">
                </el-table-column>
                <el-table-column
                    prop="applicant"
                    show-overflow-tooltip
                    
                    label="申请人姓名">
                </el-table-column>
                <el-table-column
                    prop="contactPhone"
                    show-overflow-tooltip
                    
                    width="200"
                    label="联系手机号">
                </el-table-column>
                <el-table-column
                    prop="createTime"
                    show-overflow-tooltip
                    
                    sortable="custom"
                    width="150"
                    label="提交时间">
                </el-table-column>
                <el-table-column
                    prop="rateValue"
                    show-overflow-tooltip
                    
                    label="担保进度">
                </el-table-column>
                <el-table-column
                    prop="amount"
                    show-overflow-tooltip
                    
                    label="放款金额（万元）">
                </el-table-column>
                <el-table-column
                    v-if="authorities.indexOf('sys:permission:background:guarantee:company:default:apply:list:button:view') != -1 ||
                    authorities.indexOf('sys:permission:background:guarantee:company:default:apply:list:button:edit') != -1"
                    label="操作"
                    
                    width="200">
                    <template slot-scope="scope">
                        <el-button size="small" type="primary" class="super" plain  v-if="authorities.indexOf('sys:permission:background:guarantee:company:default:apply:list:button:view') != -1" @click="check(scope.row)">查看</el-button>
                        <el-button size="small" type="primary" class="super" plain  v-if="authorities.indexOf('sys:permission:background:guarantee:company:default:apply:list:button:edit') != -1" @click="updateProgress(scope.row)">更新进度</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div class="pagination" ref="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[5, 10, 15, 20]"
                    :page-size="sendInfoOne.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalSize">
                </el-pagination>
            </div>
            <!-- 弹出成模块 -->
            <!-- 查看明细 -->
            <el-dialog
                title="申请信息"
                :visible.sync="dialogInfo"
                width="50%">
                <div class="basic">
                    <div class="boxChild">
                        <div class="basisTitle">提交信息</div>
                        <div class="child">
                            <div class="name">申请人姓名：</div>
                            <div class="content">{{detailInfo.applicant}}</div>
                        </div>
                        <div class="child">
                            <div class="name">联系手机号：</div>
                            <div class="content">{{detailInfo.contactPhone}}</div>
                        </div>
                        <div class="child">
                            <div class="name">公司全称：</div>
                            <div class="content">{{detailInfo.applyCompany}}</div>
                        </div>
                        <div class="child">
                            <div class="name">说明：</div>
                            <div class="content">{{detailInfo.applyRemark}}</div>
                        </div>
                        <div class="attachment">
                            <div class="name">附件：</div>
                            <ul class="content">
                                <li v-for="(item,i) in detailInfo.fileList" :key="i">
                                    <span>{{item.fileName}}</span><i class="el-icon-download" @click="open(item)"></i>
                                </li>
                            </ul>
                        </div>
                        <div class="child">
                            <div class="name">提交时间：</div>
                            <div class="content">{{detailInfo.createTime}}</div>
                        </div>
                        <div class="child" v-if="ishide">
                            <div class="name">是否同意《信息采集协议》：</div>
                            <div class="content">是</div>
                        </div>
                    </div>
                    <div class="boxChild">
                        <div class="basisTitle">担保进度信息</div>
                        <div class="child">
                            <div class="name">担保进度：</div>
                            <div class="content">{{detailInfo.rateValue}}</div>
                        </div>
                        <div class="child">
                            <div class="name">放款金额：</div>
                            <div class="content">{{detailInfo.amount}}</div>
                        </div>
                        <div class="child">
                            <div class="name">说明：</div>
                            <div class="content">{{detailInfo.checkExplanation}}</div>
                        </div>
                        <div class="child">
                            <div class="name">更新账号：</div>
                            <div class="content">{{detailInfo.modifyUserName}}</div>
                        </div>
                        <div class="child">
                            <div class="name">更新时间：</div>
                            <div class="content">{{detailInfo.updateTime}}</div>
                        </div>
                    </div>
                </div>
            </el-dialog>
            <!-- 审核 -->
            <el-dialog
                title="审核"
                :visible.sync="dialogAudit"
                width="30%">
                <div class="forms">
                    <div class="child">
                        <div class="name"><span>*</span>担保进度：</div>
                        <div class="content">
                            <el-select v-model="sendInfoTwo.rate" placeholder="请选择" size="small" style="width:100%;">
                                <el-option
                                v-for="item in statusList"
                                :key="item.value"
                                :label="item.name"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="error" v-if="errors['sendInfoTwo.rate']">错误提示：{{errors['sendInfoTwo.rate']}}</div>
                    <div class="childradio">
                        <div class="name"><span>*</span>是否已放款：</div>
                        <ul>
                            <li><el-radio v-model="isSelect" label="1">否</el-radio></li>
                            <li><el-radio v-model="isSelect" label="2">是，放款金额（万元）：</el-radio><el-input v-model="sendInfoTwo.amount"></el-input></li>
                        </ul>
                    </div>
                    <div class="errors">
                        <div class="error" v-if="errors['isSelect']">错误提示：{{errors['isSelect']}}</div>
                        <div class="error" v-if="errors['sendInfoTwo.amount']">错误提示：{{errors['sendInfoTwo.amount']}}</div>
                    </div>
                    <div class="childTextarea">
                        <div class="name">说明：</div>
                        <div class="content"><el-input type="textarea" v-model="sendInfoTwo.dealWithRemark" show-word-limit maxlength="200" style="max-width:100%;"></el-input></div>
                    </div>
                    <div class="doubleBtn">
                        <el-button size="small" type="primary" @click="submit">确认</el-button>
                        <el-button size="small" @click="cancel">取消</el-button>
                    </div>
                </div>
            </el-dialog>
        </div>
    
</template>

<script>

// import breadcrumb from '../../components/breadcrumb';
import {getDict} from "@/axios";
import timeMixins from "@/mixins/timeFormat";
export default {
    mixins:[timeMixins],
    components:{
        // breadcrumb
    },
    data(){
        return{
            loading:false,
            bHeight: void 0,
            ishide:false,
            authorities:JSON.parse(window.localStorage.getItem('authorities')),
            options: [{
                value: '2',
                label: '账号'
                }, {
                value: '3',
                label: '姓名'
            },{
                value: '4',
                label: '申请人姓名'
            }, {
                value: '5',
                label: '联系手机号'
            }],//检索下拉
            sendInfoOne:{
                currentPage:1,//当前页
                pageSize:10,//页条数
                rate:'',//进度
                id:"",//申请id
                userName:'',//账号
                name:'',//姓名
                contactPhone:'',//手机号
                applicant:"",//申请姓名
                property:null,//排序字段
                direction:null,//排序方式
                endDate:'',//结束时间
                startDate:'',//开始时间
            },//检索提交数据
            getSelect:'',//检索下拉的值
            getValue:'',//检索输入框的值
            dateS:[],//日期
            tableData:[],//表格数据
            currentPage:1,//当前页
            dialogInfo:false,//查看明细弹出层
            dialogAudit:false,//更新进度弹出层
            sendInfoTwo:{
                applyId:'',//id
                rate:'',//担保进度
                amount:'',//是否已放款选择值
                dealWithRemark:'',//说明
            },
            isSelect:'1',
            totalSize:null,
            statusList:[],
            scopeList:[],
            detailInfo:{
                applicant:"",
                contactPhone:"",
                applyCompany:"",
                applyRemark:"",
                fileList:[],
                createTime:"",
                amount:"",
                checkExplanation:"",
                modifyUserName:"",
                updateTime:""
            }
        }
    },
    computed: {
        errors() {
            return this.$vuerify.$errors // 错误信息会在 $vuerify.$errors 内体现
        }
    },
    vuerify: {
        'sendInfoTwo.rate':{
            test:function(){
                if(this.sendInfoTwo.rate){
                    return true;
                }else{
                    return false;
                }
            },
            message:'选择担保进度'
        },
        'isSelect':{
            test:function(){
                if(this.isSelect){
                    return true;
                }else{
                    return false;
                }
            },
            message:'选择是否已放款'
        },
        'sendInfoTwo.amount':{
            test:function(){
                if(this.isSelect == 1){
                    return true
                }else{
                    if(this.sendInfoTwo.amount){
                        return true;
                    }else{
                        return false;
                    }
                }
                
            },
            message:'输入放款金额'
        },
    },
    methods:{
      onReset(){
        const param = {
          currentPage:1,//当前页
                pageSize:10,//页条数
                rate:'',//进度
                id:"",//申请id
                userName:'',//账号
                name:'',//姓名
                contactPhone:'',//手机号
                applicant:"",//申请姓名
                property:null,//排序字段
                direction:null,//排序方式
                endDate:'',//结束时间
                startDate:''//开始时间
        }
        this.sendInfoOne = Object.assign(this.sendInfoOne,param)
        this.getSelect = void 0
        this.getValue = void 0
        this.dateS = []
        this.getData()
      },
       doLayout() {
            this.$nextTick(() => {
              if (this.$refs.table && this.$refs.table.doLayout) {
                this.$refs.table.doLayout()
              }
            })
          },
          // 表头样式回调
          headerStyle() {
            return 'backgroundColor:#F7F7F7;fontSize:14px;color:#595959;fontWeight:500;padding:0;line-height:40px'
          },
        //表格排序事件
        sortChange:function({ column, prop, order }){
            if(column.label=="提交时间"){
				if(order=='ascending'){
				    order='asc';
				}else{
				    order='desc';
				}
				this.sendInfoOne.property=prop;
				this.sendInfoOne.direction=order;
				this.getData();
            }
        },
        //表格查看按钮
        check:function(row){
            if(row.vouchName == '经开区中小担'){
                this.ishide = true
            }else{
                this.ishide = false
            }
            // this.$axiosc.get('backstage/vouch/apply/details/'+row.id).then(res=>{
            //     if(res.code == 200){
            //         this.detailInfo = res.data
            //          this.dialogInfo=true;
            //     }else{
            //         this.$message({
            //             type: 'error',
            //             message: res.msg
            //         });
            //     }
            // })
            this.$router.push({path: `/guaranteeManagement/applyList/detail/${row.id}`, query: {index: '/guaranteeManagement/applyList',ishide:this.ishide},param:{id:row.id}})
        },
        //表格更新进度
        updateProgress:function(row){
            this.sendInfoTwo.applyId = row.id
            this.sendInfoTwo.rate = ''//担保进度
            this.sendInfoTwo.amount=''//是否已放款选择值
            this.sendInfoTwo.dealWithRemark=''//说明
            this.dialogAudit=true;
        },
        //取消按钮
        cancel:function(){
            this.$vuerify.clear();
            this.dialogAudit=false
        },
        //保存按钮
        submit:function(){
            this.$vuerify.clear();
            if(this.$vuerify.check()){
                this.$axiosc.put('backstage/vouch/update/progress',this.$qs.stringify(this.sendInfoTwo)).then(res=>{
                    if(res.code == 200){
                        this.getData()
                        this.$message({
                            type: 'success',
                            message: '操作成功'
                        });
                        this.dialogAudit=false
                    }else{
                        this.$message({
                            type: 'error',
                            message: res.msg
                        });
                    }
                })
            }
        },
        //分页功能模块
        //切换每页显示条数
        handleSizeChange(val) {
            this.sendInfoOne.pageSize=val;
            this.getData();
        },
        //切换页码
        handleCurrentChange(val) {
            this.sendInfoOne.currentPage=val;
            this.getData();
        },
        getData(){
            this.loading =  true
            if(this.dateS&&this.dateS.length>0){
                this.sendInfoOne.startDate=this.dateS[0];
                this.sendInfoOne.endDate=this.dateS[1];
            }else{
                this.sendInfoOne.startDate=null;
                this.sendInfoOne.endDate=null;
            }
            this.sendInfoOne.id="";//申请id
            this.sendInfoOne.userName='';//发布账号
            this.sendInfoOne.name='';//发布账号
            this.sendInfoOne.applicant='';//姓名
            this.sendInfoOne.contactPhone='';//手机号
            if(this.getSelect=='1'){ //申请id
                this.sendInfoOne.id=this.getValue;
            }else if(this.getSelect=='2'){ //账号
                this.sendInfoOne.userName=this.getValue;
            }else if(this.getSelect=='3'){ //姓名
                this.sendInfoOne.name=this.getValue;
            }else if(this.getSelect=='4'){ //申请人姓名
                this.sendInfoOne.applicant=this.getValue;
            }else if(this.getSelect=='5'){ //电话
                this.sendInfoOne.contactPhone=this.getValue;
            }
            this.$axiosc.get('backstage/vouch/apply/SAM/list',{params:this.sendInfoOne}).then(res=>{
                this.loading = false
                if(res.code==200){
                    this.tableData=res.data.content;
                    this.totalSize=res.data.totalElements;
                }else{
                    this.$alert(res.msg)
                }
            }).catch(e=>{
              this.loading = false
            })
        }
    },

    mounted(){
        const that = this
        getDict('isShow/VOUCH_RATE').then(data=>{
            that.statusList = data['isShow/VOUCH_RATE']
        })
         // 请求
        that.getData();
        let bh = 44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 25
          that.bHeight = document.body.clientHeight - 64  - bh 
          that.doLayout()
          window.onresize = () => {
            return (() => {
              that.$nextTick(() => {
                  bh =  44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 25
                  that.bHeight = document.body.clientHeight - 64  - bh 
                  that.doLayout()
              })
            })()
          }
    }
}
</script>

<style lang="scss" scoped>
.forms .child .el-input{
  max-width:100% !important;
}
</style>